import { LibertyCustomActionBox } from '../Customs/LibertyCustomActionBox/LibertyCustomActionBox';
import styles from './LibertyChangePageButton.module.scss';

const LibertyChangePageButton = ({ title, options }) => {
  return <LibertyCustomActionBox headerClass={styles.header} title={title} options={options} />;
};

export default LibertyChangePageButton;
